<template>
  <bd-tree v-if="show" :options="options"></bd-tree>
</template>

<script>
import BdTree from "../components/BDTree.vue";
export default {
  name: "company",
  created: () => {},
  components: {
    BdTree
  },
  data() {
    return {
      show: true,
      access: {},
      options: {
        entityName: "company",
        label: "name",
        fields: {
          companyName: {
            title: "نام",
            type: "text"
          }
        }
      }
    };
  },
  methods: {
    getAll() {
      new BaseService(this.params.entity)
        .getAll()
        .then(res => {});
        // .catch();
    }
  },
  beforeMount() {
    this.options.access = checkAccess(this.$route.path);
    this.show = this.options.access ? true : false;
  }
};
</script>